export type SpacesReply = {
  text?: {
    content?: string
    resources?: Array<
      | {
          type: 'document'
          document: { title: string; id: string; read: boolean }
        }
      | { type: 'url'; url: { title: string; url: string; favicon?: string } }
    >
  }
}
export type RenderableResource =
  | { kind: 'doc'; title: string; id: string; read: boolean }
  | { kind: 'url'; title: string; href: string; favicon?: string }
export function renderableResources(data?: SpacesReply): RenderableResource[] {
  const items = data?.text?.resources || []
  return items.map((x) =>
    x.type === 'document'
      ? {
          kind: 'doc' as const,
          title: x.document.title,
          id: x.document.id,
          read: x.document.read,
        }
      : {
          kind: 'url' as const,
          title: x.url.title,
          href: x.url.url,
          favicon: x.url.favicon,
        },
  )
}
export async function sendSpacesMessage(opts: {
  apiEndpoint: string
  sessionId: string
  text: string
}): Promise<SpacesReply> {
  console.log('Making API request to:', opts.apiEndpoint)
  console.log('Request payload:', {
    session_id: opts.sessionId,
    text: opts.text,
  })
  try {
    const res = await fetch(opts.apiEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ session_id: opts.sessionId, text: opts.text }),
      mode: 'cors',
    })
    console.log('Response status:', res.status)
    console.log('Response headers:', Object.fromEntries(res.headers.entries()))
    if (!res.ok) {
      const errorText = await res.text()
      console.error('API error response:', errorText)
      throw new Error(`Spaces API error ${res.status}: ${errorText}`)
    }
    const data = await res.json()
    console.log('Parsed response data:', data)
    return data
  } catch (error) {
    console.error('Fetch error:', error)
    throw error
  }
}
export function getOrCreateSessionId(key: string): string {
  const k = `quad-atlas:sid:${key}`
  let sid = localStorage.getItem(k)
  if (!sid) {
    sid =
      typeof crypto !== 'undefined' && 'randomUUID' in crypto
        ? crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(36).slice(2)}`
    localStorage.setItem(k, sid)
  }
  return sid
}
